export default __webpack_public_path__ + "static/earth_lights_2048-2e2a7ae021877422b8cef783deed2f50.png";